<template>
  <svg
    :width="props.size"
    :height="props.size"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.5 1.5V3H1.5V1.5H16.5ZM5.25 16.5H7.5V4.5H5.25V16.5ZM10.5 12H12.75V4.5H10.5V12Z"
      :fill="color"
    />
  </svg>
</template>

<script setup lang="ts">
  const props = defineProps({
    color: {
      type: String,
      default: '#0000FF',
    },
    size: {
      type: Number,
      default: 18,
    },
  })
</script>
